import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Box, Icon, Columns, Form, Button, Disclosure, Input, Level, Toasts } from '@deseretbook/react-ui'
import PaymentSourceDetails from './PaymentSourceDetails'
import { DeseretBook } from '../../../dbcom/api'
import { Logger, formatErrorMessage } from '../../../dbcom'
import { withCheckout } from '../CheckoutContext'

const logger = new Logger({ context: 'AppliedGiftCard' })

/**
 * Displays an applied gift card. This allows a user to remove a gift card from
 * the current order.
 */
class AppliedGiftCard extends Component {
  constructor() {
    super()

    this.state = {
      /** If the form is currently being submitted. */
      isSubmitting: false,
    }

    this.removeGiftCard = this.removeGiftCard.bind(this)
  }

  /**
   * Removes the gift card from the current order.
   */
  removeGiftCard() {
    const {
      order,
      updateOrder,
      startLoading,
      stopLoading,
      payment,
    } = this.props

    startLoading(() => {
      this.setState({ isSubmitting: true }, async () => {
        try {
          const removedPayment = await DeseretBook
            .order(order)
            .payment()
            .void(payment)

          const updatedOrder = await DeseretBook
            .order(order)
            .get()

          updateOrder(updatedOrder)
          this.setState({ isSubmitting: false })
          stopLoading()
          Toasts.success('Gift card removed from order')
        } catch ({ message, errors }) {
          Toasts.danger('Unable to remove gift card', formatErrorMessage(message, errors))
          logger.error(`Unable to remove gift card: "${formatErrorMessage(message, errors)}"`, { errors, order, payment })
          this.setState({ isSubmitting: false })
          stopLoading()
        }
      })
    })
  }

  /**
   * Determines how the AppliedGiftCard form should be displayed.
   */
  render() {
    const { payment, status } = this.props
    const { isSubmitting, form } = this.state

    return (
      <Level>
        <Level.Left>
          <Level.Item>
            <PaymentSourceDetails source={payment.source} amount={payment.amount} />
          </Level.Item>
        </Level.Left>
        <Level.Right>
          <Level.Item>
            <Button
              type="button"
              isLoading={isSubmitting}
              disabled={status.isLoading}
              onClick={() => this.removeGiftCard()}
              aria-label="Remove gift card"
            >
              Remove
            </Button>
          </Level.Item>
        </Level.Right>
      </Level>
    )
  }
}

export default withCheckout(AppliedGiftCard)
